import React from 'react'
import { useIntl } from 'react-intl'

import { CartLayout } from '@/components/Cart/CartLayout'
import { CurrentUserQuery } from '@/gql/graphql'
import { routes } from '@/lib/routes'

import { EditProfileForm } from './EditProfileForm'

interface Props {
  venueSlug: string
  currentUser: CurrentUserQuery['currentUser']
}

export const EditProfilePage = ({ currentUser, venueSlug }: Props) => {
  const intl = useIntl()

  return (
    <CartLayout
      title={intl.formatMessage({
        defaultMessage: 'Edit account details',
        id: 'AQGwgI',
      })}
      navBarProps={{
        backRoute: routes.guestProfile,
        pathData: { venueSlug },
      }}
    >
      <EditProfileForm currentUser={currentUser} venueSlug={venueSlug} />
    </CartLayout>
  )
}
